import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';

import { SpaDaysConnected as SpaDaysV1 } from './container';
import { SpaDaysV2 } from './v2';

type SpaDaysVersionProps = {
  categoryId?: number | null;
  language: string;
  isLoading?: boolean;
};

export const SpaDaysVersion: FC<SpaDaysVersionProps> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2.spa-days');
  if (isV2) return <SpaDaysV2 {...props} />;
  return <SpaDaysV1 {...props} />;
};
